import { PaymentMethod } from '../common/constants';
import { PriceOptions } from './bookingFormTypes';

export const enum LocationTypes {
  DaNang = 1,
  QuyNhon = 2,
}

export interface IHotelPaymentOption {
  type: PaymentMethod;
  isActive: boolean;
  order?: number;
  description?: string;
  paymentServiceId?: string;
  depositAmount?: number;
}

export interface IHotelInfo {
  hotelId: number;
  phoneNumber: string;
  address: string;
  hotelName: string;
  location: string;
  locationId: number;
  imageUrl: string;
  rooms: IRoomInfo[];
  defaultHours?: number;
  isActive?: boolean;
  loyaltyEnabled?: boolean;
  overnightTimeFrom?: string;
  overnightTimeDefault?: string;
  webPaymentServiceId?: string;
  disableRoomAssignment?: boolean;
  roomHoldMinutes?: number | null;
  paymentOptions?: IHotelPaymentOption[];
}

export interface IRoomInfo {
  roomTypeName: string;
  roomTypeId: number;
  roomImages: string[];
  roomDescription: string;
  roomUpgradeRank?: number;
}

export interface IHotelAvailability {
  AvailableRooms: number;
  RoomTypeId: number;
  RoomTypeName?: string;
  RoomPriceId: number;
  TotalPrice: number;
  TotalOriginalPrice?: number;
  PriceUnit: number;
  Quantity: number;
}

export interface ISearchAvailabilityQuery {
  from: string;
  to: string;
  priceOption: PriceOptions;
}

export interface ICreateBookingRequest {
  from: string;
  to: string;
  roomPriceId: number;
  roomTypeId: number;
  priceOption: PriceOptions;
  contactName: string;
  phoneNumber: string;
  note: string;
  emailInfo?: any;
  paymentMethod?: PaymentMethod;
  source?: string;
}

export interface ICreateBookingResponse {
  Id: number;
  ReservationId: number;
  ArrivalDate: string;
  DepartureDate: string;
  RoomId?: number;
  hasRoomAssignment?: boolean;
  requiresPayment?: boolean;
}

export interface IHotelReservationInfo {
  Fullname: string;
  Mobile: string;
  HotelId: number;
  ArrivalDate: string;
  DepartureDate: string;
  Note: string;
  /**
   * This is the reservation id in url
   */
  ReservationRoomId: number;
  /**
   * This is the actual booking reservation number
   */
  ReservationNumber: number;
  RoomTypeId: number;
  RoomTypeName: string;
  RoomId?: number;
  TotalPrice: number;
  PriceOption: PriceOptions;
  IsTaxApplied: boolean;
  BookingStatus: BookingStatus;
  PaymentStatus: PaymentStatus;
  PaymentMethod: PaymentMethod;
  loyalty?: ILoyaltyReservationInfo;
}

export interface ILoyaltyRank {
  hotelId: number;
  name: string;
  thresholdPoints: number;
  description?: string;
  award?: string;
  gift?: ILoyaltyGift;
}

export type LoyaltyGiftActionType = 'ROOM_UPGRADE' | 'EXTEND_CHECKOUT' | 'FREE_OVERNIGHT_BOOKING';

export interface ILoyaltyGift {
  actionType: LoyaltyGiftActionType;
  activeWeekdays?: number[];
  extensionHours?: number;
  startTime?: string;
  endTime?: string;
  eligibleRoomTypeIds?: number[];
}

export interface ILoyaltyGiftOption {
  actionType: LoyaltyGiftActionType;
  thresholdPoints: number;
  title: string;
  description?: string;
  targetRoomTypeId?: number;
  targetRoomTypeName?: string;
  totalPrice?: number;
  currentCheckoutAt?: string;
  extendedCheckoutAt?: string;
  extensionHours?: number;
  eligibleRoomTypeIds?: number[];
  reason?: string;
}

export interface ILoyaltyRedemptionRecord {
  id: string;
  thresholdPoints: number;
  actionType: LoyaltyGiftActionType;
  status: 'pending' | 'redeemed' | 'failed' | 'refunded';
  createdReservationId?: number;
}

export interface ILoyaltyReservationInfo {
  currentPoints: number;
  estimatedPoints: number;
  projectedPoints: number;
  currentEligibleReward?: ILoyaltyRank;
  projectedEligibleReward?: ILoyaltyRank;
  nextReward?: ILoyaltyRank;
  currentRank?: ILoyaltyRank;
  nextRank?: ILoyaltyRank;
  ranks: ILoyaltyRank[];
  redeemableGifts?: ILoyaltyGiftOption[];
  redeemedGifts?: ILoyaltyRedemptionRecord[];
}

export const enum PaymentStatus {
  NotPaid = 0,
  Paid = 1,
  Error = 2,
  Deposit = 3,
}

export const enum BookingStatus {
  BOOKED = 'BOOKED',
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  CANCELLED = 'CANCELLED',
}
